import { createFeatureFlags } from '@thehotelsnetwork/vue-feature-flags';

import { type UserInfo } from '@/declarations/main';
import auth from '@/modules/Auth';

const env = import.meta.env || {};

export const featureFlags = createFeatureFlags(
  env.VUE_APP_LAUNCHDARKLY_API_KEY,
);

export const userAdapter = (userInfo: UserInfo) => {
  const propertyCount = userInfo.properties?.length;
  return {
    kind: 'user',
    ...userInfo.user,
    id: userInfo.user.id ?? '',
    key: userInfo.user?.id,
    dmo: userInfo.user?.permissions?.destination === 2,
    dmoOnly: userInfo.user?.permissions?.destination === 2 && !propertyCount,
    hybrid: !!(userInfo.user?.permissions?.destination === 2 && propertyCount),
    propertyCount,
    isLoginAs: auth.isImpersonatedUser(),
    app: 'benchdirect',
  };
};
